import { VIcon, VTreeview } from "vuetify/lib";

export default {
	name: "KRoutableTreeview",

	props: {
		itemIcon: String,

		itemKey: {
			default: "id",
			type: String
		},

		title: {
			required: true,
			type: String
		},

		loadChildren: Function
	},

	data: () => ( {
		fetchedItems: []
	} ),

	computed: {
		items() {
			return this.fetchedItems.map( item => ( {
				id: item[this.itemKey],
				name: this.$scopedSlots.name( item )
			} ) );
		}
	},

	methods: {
		async fetchItems() {
			if ( typeof this.loadChildren === "function" ) {
				this.fetchedItems = await this.loadChildren();
			}
		}
	},

	render() {
		return <VTreeview
			activatable
			class="v-treeview--auto-height"
			hoverable
			items={[
				{
					name: this.title,
					children: this.items
				}
			]}
			loadChildren={this.fetchItems}
			on={{
				"update:active": active => {
					if ( active.length ) {
						this.$emit(
							"click:item",
							this.fetchedItems.find( item => item[this.itemKey] === active[0] )
						);
					}
				}
			}}
			openOnClick
			rounded
			scopedSlots={{
				prepend: ( { item, open } ) => {
					if ( item.children ) {
						return <VIcon>{open ? "folder_open" : "folder"}</VIcon>;
					} else if ( this.itemIcon ) {
						return <VIcon>{this.itemIcon}</VIcon>;
					}
				}
			}}
		></VTreeview>;
	}
};
